import * as React from "react"
import { cn } from "../../lib/utils"

interface FeatureBlockProps {
  /** Content for the dark text side */
  textContent: React.ReactNode
  /** Content rendered inside the light panel */
  panelContent: React.ReactNode
  /** If true, light panel goes on the left and text on the right */
  reversed?: boolean
  className?: string
}

/**
 * Two-column block inside a raised dark container.
 * One half is dark with text content, the other half is a light panel
 * that bleeds to the edge of the container with no gap.
 */
const FeatureBlock: React.FC<FeatureBlockProps> = ({
  textContent,
  panelContent,
  reversed = false,
  className,
}) => {
  return (
    <div
      className={cn(
        "bg-[#13082a] rounded-[1.5rem] border border-white/[0.06] shadow-2xl shadow-black/40 overflow-hidden",
        className
      )}
    >
      <div className={cn(
        "grid grid-cols-1 lg:grid-cols-2 min-h-[360px]",
        reversed && "lg:direction-rtl"
      )}>
        {/* Text side */}
        <div className={cn(
          "flex flex-col justify-center p-8 md:p-12 lg:p-14",
          reversed ? "lg:order-2 lg:direction-ltr" : "lg:order-1"
        )}>
          {textContent}
        </div>

        {/* Light panel — bleeds to edge */}
        <div className={cn(
          "bg-[#f4f2f7] flex flex-col justify-center p-8 md:p-10",
          reversed ? "lg:order-1 lg:direction-ltr" : "lg:order-2"
        )}>
          {panelContent}
        </div>
      </div>
    </div>
  )
}

export { FeatureBlock }
